"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectMenu = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const debounce_1 = __importDefault(require("debounce"));
const ramda_1 = require("ramda");
const menu_content_1 = require("./menu-content");
const multi_select_menu_styles_1 = require("./multi-select-menu.styles");
const loading_indicator_1 = require("../loading-indicator");
const utils_1 = require("../../utils");
const localization_1 = require("../../../localization");
const MultiSelectMenu = ({ anchorEl, anchorPosition, anchorReference, defaultSearchText = '', isLoading, isDisabled, options = [], selected, allowEmptySelection, hasNextPage, moreItemsLoading, isSubmitting, isSearching, singleSelect, strictApply, onClose, onApply, onCreate, onSearch, onLoadMore, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [searchText, setSearchText] = (0, react_1.useState)(defaultSearchText);
    const selectedValue = (0, react_1.useMemo)(() => selected !== null && selected !== void 0 ? selected : options.map(({ value }) => value), [options, selected]);
    const [selectedIds, setSelectedIds] = (0, react_1.useState)(selectedValue);
    const onSearchChanged = (0, react_1.useMemo)(() => (0, debounce_1.default)((search) => onSearch === null || onSearch === void 0 ? void 0 : onSearch(search), 250), [onSearch]);
    const isOpen = !!anchorEl || !!anchorPosition;
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            setSelectedIds(selectedValue);
        }
        else {
            setSearchText(defaultSearchText);
        }
    }, [isOpen, selectedValue, defaultSearchText]);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            setSearchText(defaultSearchText);
        }
    }, [defaultSearchText, isOpen]);
    const handleSelect = (0, react_1.useCallback)((id, isChecked) => {
        if (singleSelect) {
            if (isChecked) {
                setSelectedIds([id]);
            }
            else {
                setSelectedIds([]);
            }
        }
        else {
            // Multi-select => add/remove from the array
            setSelectedIds((prev) => (0, utils_1.updateUniqueItemListBasedOnValue)(id, isChecked)(prev));
        }
    }, [singleSelect]);
    const handleApply = () => {
        const optionsLength = options.length;
        if (optionsLength === selectedIds.length && !strictApply) {
            onApply(undefined);
        }
        else {
            onApply(selectedIds);
        }
    };
    const handleSelectAll = () => {
        setSelectedIds(filteredOptions.map(({ value }) => value));
    };
    const handleClearAll = () => setSelectedIds([]);
    const handleCreate = () => {
        onCreate === null || onCreate === void 0 ? void 0 : onCreate([searchText]);
        onClose();
    };
    const filteredOptions = (0, react_1.useMemo)(() => {
        if (onSearch) {
            return options;
        }
        return options.filter(({ label }) => label.toLowerCase().includes(searchText.toLowerCase()));
    }, [onSearch, searchText, options]);
    const areActionsDisabled = isDisabled
        || isLoading
        || (0, ramda_1.isEmpty)(filteredOptions)
        || (!allowEmptySelection && !selectedIds.length);
    const isOptionExist = (0, react_1.useMemo)(() => {
        if (!searchText)
            return false;
        return (filteredOptions.findIndex(({ value }) => (0, utils_1.areEqualCaseInsensitive)(value, searchText)) > -1);
    }, [filteredOptions, searchText]);
    const handleSearchTextChange = (e) => {
        const { value } = e.target;
        setSearchText(value);
        if (value !== searchText && onSearch) {
            onSearchChanged(value);
        }
    };
    return (react_1.default.createElement(material_1.Popover, { open: !!anchorEl || !!anchorPosition, anchorReference: anchorReference, anchorEl: anchorEl, anchorPosition: anchorPosition, onClose: onClose, TransitionProps: {
            exit: false,
            unmountOnExit: true,
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        } }, react_1.default.createElement(multi_select_menu_styles_1.StyledContainer, null, react_1.default.createElement(multi_select_menu_styles_1.StyledSearchInput, { onChange: handleSearchTextChange, value: searchText, placeholder: t({ key: onCreate ? 'SEARCH_OR_CREATE' : 'SEARCH' }), startAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "start" }, react_1.default.createElement(ui_components_1.Icon, { variant: "search", color: ui_components_1.baseColors.primaryGreen400, className: "search-icon" })), endAdornment: onCreate
            && searchText
            && !isOptionExist && (react_1.default.createElement(material_1.InputAdornment, { position: "end" }, react_1.default.createElement(material_1.IconButton, { size: "small", onClick: handleCreate }, react_1.default.createElement(ui_components_1.Icon, { variant: "plus", color: ui_components_1.baseColors.primaryGreen400, className: "search-icon" })))) }), !isDisabled && !singleSelect && (react_1.default.createElement("div", { className: "actions" }, react_1.default.createElement(ui_components_1.Button, { rounded: true, size: "small", title: t({ key: 'SELECT_ALL' }), onClick: handleSelectAll }), react_1.default.createElement(ui_components_1.Button, { rounded: true, error: true, size: "small", title: t({ key: 'CLEAR_SELECTION' }), onClick: handleClearAll }))), react_1.default.createElement(menu_content_1.MenuContent, { options: filteredOptions, isEmpty: options.length === 0, selectedIds: selectedIds, onSelect: handleSelect, onLoadMore: onLoadMore, hasNextPage: hasNextPage, moreItemsLoading: moreItemsLoading, isLoading: isLoading, isSearching: isSearching, isDisabled: isDisabled, singleSelect: singleSelect }), react_1.default.createElement(material_1.Divider, null), react_1.default.createElement("div", { className: "footer" }, react_1.default.createElement(ui_components_1.Button, { rounded: true, color: "primary", title: t({ key: 'CANCEL' }), onClick: onClose }), react_1.default.createElement(ui_components_1.Button, { rounded: true, color: "primary", title: t({ key: 'APPLY' }), variant: "contained", disabled: areActionsDisabled || isSubmitting, onClick: handleApply, endIcon: isSubmitting && react_1.default.createElement(loading_indicator_1.LoadingIndicator, null) })))));
};
exports.MultiSelectMenu = MultiSelectMenu;
exports.default = exports.MultiSelectMenu;
